<template>
  <div class="radio-group-wrapper" :class="{ disabled: disabled }">
    <ag-radio
      v-for="radio in radios"
      :key="radio.value"
      :label="radio.label"
      :value="radio.value"
      :disabled="radio.disabled || disabled"
      :model="model"
      :checked="checked === radio.value"
      :size="size"
      @change="onChange"
    />
  </div>
</template>

<script>
  export default {
    name: "RadioGroup",
    props: {
      model: String,
      radios: {
        type: Array
      },
      disabled: Boolean,
      checked: {
        type: String
      },
      size: {
        type: String,
        default: "16"
      }
    },
    methods: {
      onChange(event) {
        this.$emit("change", event.target.value);
      }
    }
  };
</script>

<style scoped lang="scss">
  .radio-group-wrapper {
    display: flex;
    flex-direction: column;

    .radio-wrapper {
      padding: 4px 0;
    }
  }
</style>
